// src/pages/MainDashboard.js
import React, { useContext } from 'react';
import '../assets/styles/DashBoard.css';
import { CompanyContext } from '../context/CompanyContext';

const CompanyDashboard = () => {
          const {companyInfo} =useContext(CompanyContext)
  return (
    <div className="d-flex flex-column min-vh-100">
      
      <header className="py-4 text-center">
        <div className="container">
          <h1 className="display-4 fw-bold pickcolor text-uppercase">
          {companyInfo.companyNameEng }
          </h1>
          <p className="lead text-muted">Empowering healthcare with innovation</p>
        </div>
      </header>

      {/* Login prompt message */}
      <div className="container my-5">
        <div className="alert alert-info text-center" role="alert">
          <strong>Attention:</strong> Please <a href="/branch-login" className="alert-link">log in</a> to get full access to the dashboard.
        </div>
      </div>

      {/* Other content can go here */}

    </div>
  );
};

export default CompanyDashboard;
